/**
 * The bounds the API enforces, restated for the control that offers them.
 *
 * Kept beside the web's own types rather than imported from platform-core: the
 * Console bundle does not depend on that package, and a slider whose range
 * disagreed with the server would let an operator choose a value that is then
 * silently refused. `preferences.integration.test.ts` asserts the server's
 * side; `ChatAppearance.test.tsx` asserts these match it.
 */
export const MIN_FONT_SIZE = 11;
export const MAX_FONT_SIZE = 24;

/** 0 means never. Mirrors the refinement in `chatPreferencesSchema`. */
export const MIN_FADE_SECONDS = 5;
export const MAX_FADE_SECONDS = 600;

/** Emote display size, independent of message font size. */
export const MIN_EMOTE_SIZE = 16;
export const MAX_EMOTE_SIZE = 48;
